module.exports = __webpack_public_path__ + "media/images/icon_time-3ca7d559c33ab8e582ecde27aa7f1663.svg";